// extracted by mini-css-extract-plugin
export var brand = "footer-module--brand--3deb5";
export var brandLogo = "footer-module--brandLogo--03799";
export var brandTagline = "footer-module--brandTagline--8aa46";
export var breedNavWrap = "footer-module--breedNavWrap--8e31e";
export var companyNavWrap = "footer-module--companyNavWrap--b50e6";
export var container = "footer-module--container--c231e";
export var copyright = "footer-module--copyright--060f5";
export var flex = "footer-module--flex--49c53";
export var footer = "footer-module--footer--954ee";
export var footerBar = "footer-module--footerBar--06dd4";
export var footerLink = "footer-module--footerLink--c2271";
export var footerMain = "footer-module--footerMain--c1be7";
export var footerMenu = "footer-module--footerMenu--d944e";
export var footerNav = "footer-module--footerNav--a20ac";
export var footerNavTitle = "footer-module--footerNavTitle--4bf8d";
export var modal = "footer-module--modal--66756";
export var navSec = "footer-module--navSec--da41a";
export var noLink = "footer-module--noLink--a5a2a";
export var open = "footer-module--open--998d2";
export var popup = "footer-module--popup--dffa6";
export var popupClose = "footer-module--popupClose--ec31e";
export var popupImage = "footer-module--popupImage--819aa";
export var popupInner = "footer-module--popupInner--39cdb";
export var popupText = "footer-module--popupText--4d1a1";
export var popupTitle = "footer-module--popupTitle--299c7";
export var references = "footer-module--references--d6e83";
export var social = "footer-module--social--01762";
export var socialFacebook = "footer-module--socialFacebook--0f895";
export var socialInstagram = "footer-module--socialInstagram--2a6cd";
export var socialTiktok = "footer-module--socialTiktok--e42aa";
export var socialWrap = "footer-module--socialWrap--41f2b";
export var stateNavWrap = "footer-module--stateNavWrap--1f83f";